import { SnackbarService } from '../../../../core/services/utils/snackbar.service';
import { ShopSelectionStore } from '../../../../core/state/shop-selection.store';
import { ResidentsService } from '../../../../core/services/residents/residents.service';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ModalCloseButtonComponent } from '../../modal-close-button/modal-close-button.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormGroupTyped } from '../../../../core/types/interfaces';
import { NOTE_CHARACTER_LIMIT } from '../../../../core/types/constants';
import { ButtonComponent } from '../../button/button.component';
import { Resident } from '../../../models/resident.model';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-note-modal',
  templateUrl: './create-note-modal.component.html',
  styleUrls: ['./create-note-modal.component.scss'],
  imports: [
    ModalCloseButtonComponent,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
  ],
})
export class CreateNoteModalComponent implements OnInit, OnDestroy {
  noteForm: FormGroupTyped<{ internalNote: string }>;
  isSaving: boolean = false;
  backdropSubscription: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { resident: Resident },
    private dialogRef: MatDialogRef<CreateNoteModalComponent>,
    private formBuilder: FormBuilder,
    private residentsService: ResidentsService,
    private shopSelectionStore: ShopSelectionStore,
    private snackbarService: SnackbarService,
    private dialog: MatDialog
  ) {
    this.noteForm = this.formBuilder.group({
      internalNote: ['', Validators.maxLength(NOTE_CHARACTER_LIMIT)],
    }) as FormGroupTyped<{ internalNote: string }>;
  }
  noteCharacterLimit = NOTE_CHARACTER_LIMIT;

  ngOnInit() {
    if (this.data.resident.internalNote) {
      this.noteForm.patchValue({
        internalNote: this.data.resident.internalNote,
      });
    }
    this.backdropSubscription = this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });
  }

  closeDialog() {
    this.dialogRef.close({ note: this.data.resident.internalNote || '' });
  }

  cancel() {
    this.noteForm.reset();
    this.dialogRef.close({ note: this.data.resident.internalNote || '' });
  }

  openDeleteConfirmation() {
    this.dialog.open(ConfirmationModalComponent, {
      width: 'auto',
      maxWidth: '540px',
      autoFocus: false,
      data: {
        message: 'Möchten Sie diese Bewohner:in Notiz wirklich löschen?',
        closable: true,
        buttons: [
          { text: 'Nein', id: 0, closeDialog: true, color: '#42405F' },
          {
            text: 'Ja, entfernen',
            id: 1,
            action: () => this.deleteNote(),
            color: '#ff6100',
          },
        ],
      },
    });
  }

  deleteNote() {
    this.residentsService
      .updateResident(new Resident({ ...this.data.resident, internalNote: '' }))
      .subscribe({
        next: () => {
          this.data.resident.internalNote = '';
          this.shopSelectionStore.patchResident(this.data.resident.id, {
            internalNote: '',
          });
          this.dialogRef.close({ note: '' });
          this.snackbarService.success('Die Notiz wurde erfolgreich gelöscht');
        },
        error: () => {
          this.isSaving = false;
        },
      });
  }

  saveNote() {
    this.isSaving = true;
    const note = this.noteForm.get('internalNote')?.value || '';
    this.residentsService
      .updateResident(
        new Resident({
          ...this.data.resident,
          roomNumber: this.data.resident.roomNumber ?? '',
          internalNote: note,
        })
      )
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.data.resident.internalNote = note;
          this.shopSelectionStore.patchResident(this.data.resident.id, {
            internalNote: note,
          });
          this.dialogRef.close({ note });
          this.snackbarService.success('Die Notiz wurde erfolgreich angelegt');
        },
        error: () => {
          this.isSaving = false;
        },
      });
  }

  ngOnDestroy() {
    this.backdropSubscription.unsubscribe();
  }
}
